<template>
  <div class="projectDetail" style="min-width: 1900px;">
    <div
      class="projectDetail_top"
      v-if="
        projectInfo.projectDTO.projectTypearr &&
          projectInfo.projectDTO.projectDate
      "
    >
      <div
        class="projectDetail_top_area"
        :style="
          projectInfo.productDTOList.length == 0 && trendsList.length == 0
            ? 'padding-bottom: 50px;'
            : ''
        "
      >
        <div class="projectDetail_top_projectName">
          {{ projectInfo.projectDTO.projectName }}
        </div>
        <div class="projectDetail_top_area_unit">
          项目单位：{{ projectInfo.projectDTO.projectUnit }}
          <span style="cursor: default"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;基地周期：
            {{ projectInfo.projectDTO.projectDate.split(",")[0] }}
            至
            {{ projectInfo.projectDTO.projectDate.split(",")[1] }}</span
          >
        </div>

        <div class="ProjectBase" style="margin-top: 45px;">
          <div style="">
            基地类型：{{ projectInfo.projectDTO.projectTypearr.join("、") }}
          </div>
          <div class="ProjectBase_punctuation">/</div>
          <div style="">种植面积：{{ projectInfo.base.plantedNumber }}亩</div>
          <div class="ProjectBase_punctuation">/</div>
          <div>负责人员： {{ projectInfo.base.projectPrincipal }} &nbsp;</div>
        </div>
        <div
          class="ProjectBase"
          style=""
          v-if="reportList && reportList.length > 0"
        >
          <div style="" v-if="reportList[reportList.length - 1].plantingTime">
            种植时间 ：
            {{
              reportList[reportList.length - 1].plantingTime
                .split(",")[0]
                .slice(0, -3)
                .replaceAll(" ", "")
            }}至{{
              reportList[reportList.length - 1].plantingTime
                .split(",")[1]
                .slice(0, -3)
                .replaceAll(" ", "")
            }}
          </div>
          <div v-else>种植时间 ：--</div>
          <div class="ProjectBase_punctuation">/</div>
          <div style="" v-if="reportList[reportList.length - 1].Harvest_Time">
            收成时间：
            {{
              reportList[reportList.length - 1].Harvest_Time.split(",")[0]
                .slice(0, -3)
                .replaceAll(" ", "") +
                "至" +
                reportList[reportList.length - 1].Harvest_Time.split(",")[1]
                  .slice(0, -3)
                  .replaceAll(" ", "")
            }}
          </div>
          <div v-else>收成时间：--</div>
          <div class="ProjectBase_punctuation">/</div>
          <div>预估产值：{{ reportList[reportList.length - 1].Estimated_Output }}</div>
        </div>

        <div class="projectDetail_top_area_download">
          <img
            :class="
              reportList &&
              reportList.length > 0 && reportList[0].reportObjImg[0].url &&
              reportList[0].predicted_Yield
                ? 'moveTop'
                : ''
            "
            :src="
              reportList && reportList.length && reportList[0].predicted_Yield
                ? require('../../static/newImg/projectList_bg6.png')
                : require('../../static/newImg/projectList_bg8.png')
            "
            width="300px"
            height="67px"
            :style="
              reportList &&
              reportList.length > 0 &&
              reportList[0].predicted_Yield
                ? 'cursor: pointer'
                : ''
            "
            @click="changeReport"
          />
          <el-image
            style="width: 300px; height: 67px;margin: 0 32px;"
            :src="require('../../static/newImg/projectList_bg5.png')"
            @click="changeProjectInsure"
          ></el-image>
          <img
            :class="siteList && siteList.length > 0 ? 'moveTop' : ''"
            src="../../static/newImg/projectList_bg4.png"
            width="300px"
            height="67px"
            :style="siteList && siteList.length > 0 ? 'cursor: pointer' : ''"
            @click="changeSite"
          />
        </div>
        <div
          class="projectDetail_product"
          v-if="projectInfo.productDTOList.length > 0"
        >
          <div class="productPresentation_top_area">
            <div class="productPresentation_head_content_title_right">
              <img src="../../static/newImg/Ricon1.png" alt="" width="22px" />
            </div>
            产品详情
            <div class="productPresentation_head_content_title_left">
              <img src="../../static/newImg/Licon1.png" alt="" width="22px" />
            </div>
          </div>
          <div class="projectList_line"></div>
          <div
            style="width: 1160px;margin: 70px auto 0 auto;overflow: hidden;position: relative;"
          >
            <div class="swiper-container1">
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  style="display: flex;align-items: center;"
                  v-for="(item, index) in projectInfo.productDTOList"
                  :key="index"
                >
                  <img
                    :src="item.projectProductImage"
                    alt=""
                    width="560px"
                    height="306px"
                    v-if="isMobile"
                    style="border-radius: 12px;"
                    @click="showImageDialog([item.projectProductImage])"
                  />
                  <el-image
                    style="border-radius: 12px;height: 306px;width: 560px;"
                    :src="item.projectProductImage"
                    v-if="!isMobile"
                    :preview-src-list="[item.projectProductImage]"
                  ></el-image>
                  <div
                    style="margin-left: 32px;width: calc(100% - 600px);position: relative;"
                  >
                    <div
                      style="font-size: 28px;text-align: left;font-weight: 600;"
                    >
                      {{ item.projectProductName }}
                    </div>
                    <div
                      style="font-size: 18px;text-align: justify;margin-top: 21px;line-height: 34px;height: 170px;overflow: hidden;"
                    >
                      {{ item.projectProductDesc }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="container1 && projectInfo.productDTOList.length > 1"
              style="position: absolute;bottom: 0;left: 51%;display: flex;z-index: 9;"
            >
              <div
                v-for="(item, index) in projectInfo.productDTOList"
                :key="index"
                class="swiper-pagination-bullet1"
                @mouseover="changeSlide(index)"
                :style="{
                  background:
                    container1.activeIndex == index
                      ? 'rgba(255, 255, 255, 0.90)'
                      : '',
                }"
              ></div>
            </div>
          </div>
        </div>
        <div class="projectDetail_news" v-if="trendsList.length > 0">
          <div class="productPresentation_top_area">
            <div class="productPresentation_head_content_title_right">
              <img src="../../static/newImg/Ricon1.png" alt="" width="22px" />
            </div>
            最新动态
            <div class="productPresentation_head_content_title_left">
              <img src="../../static/newImg/Licon1.png" alt="" width="22px" />
            </div>
          </div>
          <div class="projectList_line"></div>
          <div
            style="width: 1200px;margin: 50px auto;"
            v-if="trendsList.length > 0"
          >
            <div
              class="projectDetail_news_content"
              v-for="(item, index) in trendsList"
              :key="item.trendsId"
            >
              <div style="display: flex;align-items: center;">
                <img
                  src="../../static/newImg/projectDetail_bg3.png"
                  width="30px"
                />
                <div style="font-size: 26px;margin-left: 30px;">
                  更新日期：{{ item.trendsDate }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  巡检人员：{{ item.inspector }}
                </div>
              </div>
              <div
                style="text-align: left;margin-top: 20px;font-size: 26px;padding-left: 60px;"
              >
                {{ item.trendsTitle }}
              </div>
              <div style="display: flex;flex-wrap: wrap;padding-left: 60px;">
                <div
                  @click="toDetail(item.projectId)"
                  class="moveTop"
                  style="height: 50px;background: rgba(0, 0, 0, 0.2);border-radius: 5px;line-height: 50px;margin: 20px 20px 0 0;padding: 0 36px;color: #FFEA5B;cursor: pointer;font-size: 22px"
                >
                  #{{ item.otherProjectName }}
                </div>
                <div
                  style="height: 50px;background: rgba(0, 0, 0, 0.2);border-radius: 5px;line-height: 50px;margin: 20px 20px 0 0;padding: 0 36px;font-size: 22px"
                >
                  #{{ item.trendsTagName }}
                </div>
              </div>
              <div
                style="display: flex;margin-top: 10px;flex-wrap: wrap;justify-content: flex-start;padding-left: 60px;align-items: flex-end;"
              >
                <el-image
                  style="margin: 20px 20px 0 0;border-radius: 6px;width: 330px;height: 280px;"
                  :src="item1"
                  v-for="(item1, index) in item.preImgList2"
                  :key="index + '123'"
                  v-if="!isMobile"
                  :preview-src-list="item.preImgList2"
                ></el-image>
                <img
                  :src="item1"
                  width="330px"
                  height="280px"
                  v-for="(item1, index) in item.preImgList2"
                  style="margin: 20px 10px 0 10px;border-radius: 6px;"
                  :key="index + '111'"
                  v-if="isMobile"
                  @click="showImageDialog(item.preImgList2, index)"
                />
                <img
                  src="../../static/newImg/projectList_bg15.png"
                  width="60px"
                  height="280px"
                  class="moveTop"
                  style="cursor: pointer;"
                  @click="toDetail(item.projectId, 'down')"
                />
              </div>
              <div
                style="margin: 80px 0 ;width: 1160px;height: 2px;background: linear-gradient( 90deg, rgba(255,255,255,0) 0%, #FFFFFF 48%, rgba(255,255,255,0) 100%);border-radius: 48px;opacity: 0.1;"
                v-show="index < trendsList.length - 1"
              ></div>
            </div>
          </div>
          <div v-show="trendsListAll.length > 3">
            <img
              src="../../static/newImg/projectList_bg10.png"
              @click="showDDialog"
              class="moveTop"
              style="width: 1100px;margin: 30px auto 30px auto;cursor: pointer;"
            />
          </div>
          <div v-show="trendsListAll.length < 4" style="height: 20px;"></div>
        </div>
      </div>
      <!-- 基地切换 -->
      <div style="overflow: hidden;position: relative;">
        <div
          style="position: absolute;left: 0;top: 0;height: 90px;width: 100%;z-index: 7;display: flex;background-color: #012F06;"
        >
          <div style="width: 33.3%;height: 90px;"></div>
          <div
            style="width: 33.3%;height: 90px;background-color: #106022;"
          ></div>
          <div style="width: 33.3%;height: 90px;"></div>
        </div>
        <div class="swiper-container4">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide projectList_slide"
              v-for="(item, index) in collectionList"
              :key="index"
            >
              <div
                style="
                    cursor: pointer;
                    font-weight: bold;line-height: 90px;
                  "
                @click="changeBase(index)"
              >
                基地{{
                  index == 0
                    ? "一"
                    : index == 1
                    ? "二"
                    : index == 2
                    ? "三"
                    : index == 3
                    ? "四"
                    : index == 4
                    ? "五"
                    : index == 5
                    ? "六"
                    : index == 6
                    ? "七"
                    : index == 7
                    ? "八"
                    : index == 8
                    ? "九"
                    : index == 9
                    ? "十"
                    : index == 10
                    ? "十一"
                     : index == 11
                    ? "十二"
                    : index == 12
                    ? "十三"
                     : index == 13
                    ? "十四"
                     : index == 14
                    ? "十五"
                     : index == 15
                    ? "十六"
                     : index == 16
                    ? "十七"
                     : index == 17
                    ? "十八"
                     : index == 18
                    ? "十九"
                     : index == 19
                    ? "二十"
                     : index == 20
                    ? "二十一"
                     : index == 21
                    ? "二十二"
                     : index == 22
                    ? "二十三"
                     : index == 23
                    ? "二十四"
                     : index == 24
                    ? "二十五"
                     : index == 25
                    ? "二十六" : "二十七" }}
                ·
                {{ item.projectName }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 基地详情 -->
    <!-- projectList_bg12 -->
    <div
      class="projectDetail_productPresentation_base"
      v-if="collectionList.length > 0 && projectInfoChild.projectDTO"
    >
      <img
        src="../../static/newImg/projectList_bg12.png"
        width="72px"
        style="position: absolute;top: 0; left: calc(50% - 36px);"
      />
      <img
        src="../../static/newImg/projectList_bg13.png"
        width="98px"
        height="98px"
        :style="showProjectBaseIndex != 0 ? '' : 'opacity: 0;'"
        style="cursor: pointer;"
        class="moveTop"
        @click="changeBase(showProjectBaseIndex - 1)"
      />
      <div class="projectDetail_productPresentation_base_content">
        <div class="productPresentation_top_area" style="color: #fff;">
          {{ collectionList[showProjectBaseIndex].projectName }}
        </div>
        <div
          class="projectList_line"
          style="width: 1200px;margin-top: 20px;"
        ></div>
        <div
          style="display: flex;margin: 35px auto;flex-wrap: wrap;text-align: left;font-size: 22px;color: #E1EAD1;line-height: 40px;padding: 0 20px;"
        >
          <div style="width: 60%">
            项目单位：{{ projectInfoChild.projectDTO.projectUnit }}
          </div>
          <div style="width: 40%;">
            责任主体：{{ projectInfoChild.base.subjectLiability }}
          </div>
          <div style="width: 60%">
            合同年限：{{
              projectInfoChild.projectDTO.projectDate.split(",")[0]
            }}
            至
            {{ projectInfoChild.projectDTO.projectDate.split(",")[1] }}
          </div>
          <div style="width: 40%;">
            负责人员：{{ projectInfoChild.base.projectPrincipal }}
          </div>
          <div style="width: 60%" v-if="projectInfoChild.base.plantingDensity">
            种植密度：{{ projectInfoChild.base.plantingDensity }}株/亩左右
          </div>
          <div
            style="width: 60%"
            v-if="projectInfoChild.base.plantingDensityStr"
          >
            种植密度：{{ projectInfoChild.base.plantingDensityStr }}种籽/亩左右
          </div>
          <div
            style="width: 60%"
            v-if="
              !projectInfoChild.base.plantingDensityStr &&
                !projectInfoChild.base.plantingDensity
            "
          >
            种植密度：暂无
          </div>
          <div style="width: 40%">
            村集体 ： {{ projectInfoChild.base.villageCollective }}
          </div>
          <div style="width: 60%;">
            种植面积：{{ projectInfoChild.base.plantedNumber }}亩
          </div>
          <div style="width: 40%;">
            巡检人员：{{ projectInfoChild.base.inspection }}
            {{ projectInfoChild.base.inspectionPhone }}
          </div>
        </div>
        <el-carousel
          v-show="imglist1.length > 0"
          class="el-carousel_head_content_title_left imgList1"
          ref="imgList1"
          :interval="5000"
          arrow="always"
          :indicator-position="imglist1.length == 1 ? 'none' : 'inside'"
          :autoplay="true"
          height="600px"
        >
          <el-carousel-item v-for="(item, index) in imglist1" :key="index">
            <div style="display: flex; height: 100%; justify-content: center">
              <div class="carousel_left">
                <div
                  class="carousel_left_bg"
                  style="font-size: 32px;text-align: left;line-height: 180px;padding-left: 40px;z-index: 9;"
                  v-if="
                    projectInfoChild.base.resource[0] &&
                      projectInfoChild.base.resource[0].periodName
                  "
                >
                  {{ projectInfoChild.base.resource[0].periodName }}
                </div>
                <el-image
                  style="width: 1250px;"
                  :src="item"
                  v-if="item.indexOf('.mp4') == -1 && !isMobile"
                  :preview-src-list="preImgList1"
                ></el-image>
                <img
                  style="width: 1250px;"
                  :src="item"
                  v-if="item.indexOf('.mp4') == -1 && isMobile"
                  @click="showImageDialog(preImgList1, index)"
                />
                <video
                  controls
                  :id="'videoPlayer' + index"
                  :src="item"
                  v-if="item.indexOf('.mp4') > 0"
                  class="video-js"
                ></video>
                <!-- <video :poster="imglist1[1]" :id="'videoPlayer' + index" :src="item" controls preload="auto"
                  v-if="item.indexOf('.mp4') > 0 && deviceType == 'IOS'"></video> -->
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
        <div
          @click="toDetail(collectionList[showProjectBaseIndex].projectId)"
          class="moveTop"
          style="width: 100%;height: 120px;background: rgba(22, 107, 44, .3);border-radius: 30px;text-align: center;line-height: 120px;font-size: 32px; color: #fff;margin: 0 auto;margin-top: 60px;cursor: pointer;"
        >
          查看详细信息
        </div>
      </div>
      <img
        src="../../static/newImg/projectList_bg14.png"
        width="98px"
        height="98px"
        :style="
          showProjectBaseIndex != collectionList.length - 1 ? '' : 'opacity: 0;'
        "
        style="cursor: pointer;"
        class="moveTop"
        @click="changeBase(showProjectBaseIndex + 1)"
      />
    </div>
    <el-dialog
      title=""
      class="site_dialog_outside"
      :visible.sync="siteDialogVisible"
      :width="siteDialogWidth"
      center
      :append-to-body="true"
      top="50vh"
    >
      <div class="site_Dialog">
        <div
          class="site_Dialog_item"
          v-for="item in siteList"
          :key="item.name + 'site'"
        >
          <div class="site_Dialog_item_img">
            <el-image
              style="width: 85%; height: 100%"
              :src="item.siteimg[0].url"
              :preview-src-list="item.siteimgList"
            ></el-image>
          </div>
          <div class="site_Dialog_item_title">
            <div class="site_Dialog_item_title_label">
              <span>站点名：</span>{{ item.siteName }}
            </div>
            <div class="site_Dialog_item_title_label">
              <span>详细地址：</span>{{ item.detAddress }}
            </div>
            <div class="site_Dialog_item_title_label">
              <span>联系人：</span>{{ item.contacts }}
            </div>
            <div class="site_Dialog_item_title_label">
              <span>联系电话：</span>{{ item.phone }}
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title=""
      class="report_dialog_outside"
      :visible.sync="reportDialogVisible"
      :width="reportDialogWidth"
      center
      :append-to-body="true"
      top="50vh"
    >
      <div class="report_Dialog">
        <div
          class="report_Dialog_item"
          v-for="(item, index) in reportList"
          :key="item.predicted_Yield + 'report'"
        >
          <div class="report_Dialog_item_img" v-if="item.reportObjImg[0]">
            <el-image
              style="width: 100%;height: 100%;"
              :src="item.reportObjImg[0].url"
              v-if="!isMobile"
              :preview-src-list="item.reportObjImgList"
            ></el-image>
            <img
              style="width: 100%;height: 100%;"
              :src="item.reportObjImg[0].url"
              v-if="isMobile"
              @click="showImageDialog(item.reportObjImgList, 0)"
            />
          </div>
          <div class="report_Dialog_item_title">
            <div class="report_Dialog_item_title_label">
              <span>预测产量：</span>{{ item.predicted_Yield ? item.predicted_Yield : '--' }}
            </div>
            <div class="report_Dialog_item_title_label">
              <span>预估产值：</span>{{ item.Estimated_Output ? item.Estimated_Output : '--' }}
            </div>
            <div class="report_Dialog_item_title_label">
              <span>种植密度：</span>{{ item.planting_Density ? item.planting_Density : '--' }}
            </div>
            <div
              class="report_Dialog_item_title_label"
              v-if="
                item.Harvest_Time &&
                  item.Harvest_Time.split(',')[0] &&
                  item.Harvest_Time.split(',')[1]
              "
            >
              <span>收成时间：</span
              >{{
                item.Harvest_Time.split(",")[0].slice(0, -3) +
                  "至 " +
                  item.Harvest_Time.split(",")[1].slice(0, -3)
              }}
            </div>
            <div class="report_Dialog_item_title_label" v-else><span>收成时间：</span
              >--</div>
            <div class="report_Dialog_item_title_label">
              <span>评估日期：</span>{{ item.assess_Date ? item.assess_Date : '--' }}
            </div>
            <div
              class="report_Dialog_item_title_more" v-show="item.reportObjImg.length > 0"
              @click="triggerClickImgList('reportImgList1', item.reportObjImg)"
            >
              查看详情<i
                class="el-icon-arrow-right"
                style="font-size: 16px"
              ></i>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title=""
      class="dynamic_dialog_outside"
      :visible.sync="dynamicDialogVisible"
      :width="dynamicDialogWidth"
      center
      :show-close="false"
      :append-to-body="true"
      :top="isMobile ? '70vh' : '50vh'"
    >
      <div style="text-align: center;color: #FFFFFF;">
        <div
          class="projectDetail_news"
          style="position: relative;"
          v-if="trendsListAll.length > 0"
        >
          <div
            style="width: 1200px;position: absolute;top: 140px;left: 0;height: 60px;background: linear-gradient( 180deg, #0D3A1D 0%, rgba(13,58,29,0) 100%);z-index: 9;"
          ></div>
          <div
            style="width: 1200px;position: absolute;bottom: -1px;left: 0;height: 60px;background: linear-gradient( 180deg, rgba(13,58,29,0) 0%, #0D3A1D 100%);z-index: 9;"
          ></div>
          <img
            src="../../static/newImg/projectList_bg16.png"
            alt=""
            width="56px"
            style="position: absolute;top: 10px; right: 10px;cursor: pointer;"
            @click="dynamicDialogVisible = false"
          />
          <div class="productPresentation_top_area" style="padding-top: 30px;">
            <div class="productPresentation_head_content_title_right">
              <img src="../../static/newImg/Ricon1.png" alt="" width="22px" />
            </div>
            最新动态
            <div class="productPresentation_head_content_title_left">
              <img src="../../static/newImg/Licon1.png" alt="" width="22px" />
            </div>
          </div>
          <div class="projectList_line"></div>
          <div
            style="width: 1200px;margin: 30px auto 10px auto;height: 70vh;overflow-y: auto;position: relative;overflow-x: hidden;"
            :style="{ height: isMobile ? '100vh' : '70vh' }"
            v-if="trendsListAll.length > 0"
          >
            <div
              class="projectDetail_news_content"
              v-for="(item, index) in trendsListAll"
              :key="item.trendsId"
            >
              <div style="display: flex;align-items: center;">
                <img
                  src="../../static/newImg/projectDetail_bg3.png"
                  width="30px"
                />
                <div style="font-size: 26px;margin-left: 30px;">
                  更新日期：{{ item.trendsDate }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  巡检人员：{{ item.inspector }}
                </div>
              </div>
              <div
                style="text-align: left;margin-top: 16px;font-size: 24px;padding-left: 60px;color: #D0DED5;line-height: 34px;"
              >
                {{ item.trendsTitle }}
              </div>
              <div style="display: flex;flex-wrap: wrap;padding-left: 60px;">
                <div
                  @click="toDetail(item.projectId)"
                  class="moveTop"
                  style="height: 50px;background: rgba(0, 0, 0, 0.2);border-radius: 5px;line-height: 50px;margin: 20px 20px 0 0;padding: 0 36px;color: #FFEA5B;cursor: pointer;font-size: 22px;"
                >
                  #{{ item.otherProjectName }}
                </div>
                <div
                  style="height: 50px;background: rgba(0, 0, 0, 0.2);border-radius: 5px;line-height: 50px;margin: 20px 20px 0 0;padding: 0 36px;font-size: 22px;"
                >
                  #{{ item.trendsTagName }}
                </div>
              </div>
              <div
                style="display: flex;margin-top: 10px;flex-wrap: wrap;justify-content: flex-start;padding-left: 60px;align-items: flex-end;margin-bottom: 60px;"
              >
                <el-image
                  style="margin: 20px 20px 0 0;border-radius: 6px;width: 330px;height: 280px;"
                  :src="item1"
                  v-for="(item1, index) in item.preImgList2"
                  :key="index + '123'"
                  v-if="!isMobile"
                  :preview-src-list="item.preImgList2"
                ></el-image>
                <img
                  :src="item1"
                  width="330px"
                  height="280px"
                  v-for="(item1, index) in item.preImgList2"
                  style="margin: 20px 10px 0 10px;border-radius: 6px;"
                  :key="index + '111'"
                  v-if="isMobile"
                  @click="showImageDialog(item.preImgList2, index)"
                />
                <img
                  src="../../static/newImg/projectList_bg15.png"
                  width="60px"
                  height="280px"
                  class="moveTop"
                  style="cursor: pointer;"
                  @click="toDetail(item.projectId, 'down')"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <div>
      <el-image
        style="display: none"
        :src="require('../../static/newImg/img91.jpg')"
        :preview-src-list="srcList1"
        ref="reportImgList1"
      ></el-image>
    </div>
  </div>
</template>
<script>
import { Swiper } from "swiper";
import { ImagePreview } from "vant";
import {
  getPojectDetail,
  getTrends,
  getProgress,
  getSignature,
  getLandDetail,
  getCompanyDetailById,
  getPojectCollection,
} from "@/api/index.js";
export default {
  name: "projectDetail",
  data() {
    return {
      projectInfoChild: {},
      collectionList: [
        {
          projectName: "",
        },
      ],
      otherProjectName: "",
      imgSuffixTime: null,
      imgSuffix: "?x-oss-process=image/resize,m_lfit,w_300",
      projectDesc:
        "新昌县沃洲镇黄坛村平顶山项目基地,隶属于浙江中峪道地药材有限公司绍兴市级区域范围内。成片种植浙八味之首白术,土地规模整村推进完整闭环100亩,一年生的道地白术种苗种植时间2023年12月至2024年2月,收成时间2025年10月至2026年1月。拟定生长周期为两年期,届时交付市场。基地在浙江中峪控股集团的高度引领下,由农业版块专业项目负责人统筹科学管理;农科院、农技站等白术种植专家常年驻扎指导基地技术工作;并聘请当地有经验的老百姓进行种植养护工作。全方面保障中峪道地药材平顶山项目基地的先进样板落地闭环。浙江中峪道地药材有限公司已经被评为新昌沃洲重点农业企业,并被授予第一批“共富工坊”荣誉称号。",
      siteDialogWidth: "1000px",
      siteDialogVisible: false,
      reportDialogWidth: "1000px",
      reportDialogVisible: false,
      dynamicDialogVisible: false,
      dynamicDialogWidth: "1300px",
      styId: 0,
      projectId: 0,
      projectInfo: {
        base: {},
        landDTOList: {},
        productDTOList: {},
        projectDTO: {},
      },
      imgAndVideo: [],
      container1: null,
      container1Index: 0,
      current: 1,
      trendsList: [
        {
          trendsDate: "",
          inspector: "",
          trendsTitle: "",
          trendsTagName: "",
        },
      ],
      trendsListAll: [],
      myPlayer4: null,
      myPlayer5: null,
      container2: null,
      container3: null,
      container4: null,
      container5: null,
      showMore: true,
      listItem: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
      container: 0,
      activeIndex: 0,
      ImageAndVideoIndex: 0,
      showProgessTips: true,
      showTrendTips: true,
      showProgessDate: "",
      showTrendDate: "",
      containerland: null,
      imglist1: [],
      preImgList1: [],
      preImgList2: [],
      preImgList3: [require("../../static/newImg/img86.jpg")],
      imgList2: [
        require("../../static/newImg/img95.jpg"),
        "https://shituoshili-dev-001.oss-cn-hangzhou.aliyuncs.com/test/2024-06-05/a0f6fe32e04347b09777330e5dabc153.jpg",
      ],
      imgLandList: [],
      landInfo: [{ imgLandList: [] }],
      scheduleIndex: 0,
      scheduleList: [],
      imgList3: [],
      deviceType: "",
      srcList1: [
        require("../../static/newImg/img91.jpg"),
        require("../../static/newImg/img92.jpg"),
      ],
      srcList2: [require("../../static/newImg/img90.jpg")],
      srcList3: [
        "https://shituoshili-dev-001.oss-cn-hangzhou.aliyuncs.com/test/2024-06-05/85742d756a1a4ba3b4d7437a3d9bc5e4.jpg",
      ],
      productList: [],
      productsActiveIndex: 0,
      siteList: [],
      projectInsureList: [],
      reportList: [],
      companyArr: [],
      companyItem: null,
      landLength: 0,
      isMobile: false,
      showProjectBaseIndex: 0,
    };
  },
  watch: {
    reportDialogVisible(val) {
      if (val) {
        document.body.style = "overflow: hidden;";
        const report_dialog = document.getElementsByClassName(
          "report_dialog"
        )[0];
        if (report_dialog) {
          document.body.append(report_dialog);
        }
      } else {
        document.body.style = "";
        const report_dialog = document.getElementsByClassName(
          "report_dialog"
        )[0];
        if (report_dialog) {
          document
            .getElementsByClassName("projectDetail")[0]
            .append(report_dialog);
        }
      }
    },
  },
  filters: {
    fomatterDate: (val) => {
      if (val.length > 11) {
        val = val.replace("-", "年");
        val = val.replace("-", "月");
        val = val.replace("-", "年");
        val = val.replace("-", "月");
        val = val.replace(",", "日 - ");
        val += "日";
      } else {
        val = val.replace("-", "年");
        val = val.replace("-", "月");
        val += "日";
      }
      return val;
    },
  },
  mounted() {
    const userAgent = navigator.userAgent;
    const mobileKeywords = /Mobile|Android|iPhone|iPad|iPod|Windows Phone/i;
    this.isMobile = mobileKeywords.test(userAgent);
    let company;
    if (this.$route.query.companyId) {
      getCompanyDetailById(this.$route.query.companyId).then((res) => {
        company = res.data;
        this.$store.commit("setCompany", company);
        this.companyItem = company;
        this.imgSuffixTime = setTimeout(() => {
          this.imgSuffix = "";
        }, 4000);
        window.scroll(0, 0);
        this.projectId = this.$route.query.id;
        this.getPojectDetail();
        this.getTrends(1);
        const that = this;
        this.containerland = new Swiper(".swiper-containerland", {
          slidesPerView: "auto",
          spaceBetween: 24,
        });
        setTimeout(() => {
          if (this.$refs.imgList1) {
            this.slideBanner1();
          }
        }, 500);
        if (this.$refs.imgList2) {
          this.slideBanner2();
        }
        if (this.$refs.imgList3) {
          this.slideBanner3();
        }
        if (this.$refs.imgList4) {
          this.slideBanner4();
        }
        this.getScheduleList();
        this.getWXInfo();
      });
    } else {
      company = this.$store.getters.getCompany;
      this.companyItem = company;
      this.imgSuffixTime = setTimeout(() => {
        this.imgSuffix = "";
      }, 4000);
      window.scroll(0, 0);
      this.projectId = this.$route.query.id;
      this.getPojectDetail();
      this.getTrends(1);
      const that = this;
      this.containerland = new Swiper(".swiper-containerland", {
        slidesPerView: "auto",
        spaceBetween: 24,
      });
      setTimeout(() => {
        if (this.$refs.imgList1) {
          this.slideBanner1();
        }
      }, 500);
      if (this.$refs.imgList2) {
        this.slideBanner2();
      }
      if (this.$refs.imgList3) {
        this.slideBanner3();
      }
      if (this.$refs.imgList4) {
        this.slideBanner4();
      }
      this.getScheduleList();
      this.getWXInfo();
    }
    this.$nextTick(() => {
      setTimeout(() => {
        const that = this;
        this.container4 = new Swiper(".swiper-container4", {
          slidesPerView: 3,
          centeredSlides: true,
          observer: true, //开启动态检查器，监测swiper和slide
          observeParents: true, //监测Swiper 的祖/父元素
          on: {
            slideChange: function(val) {
              document.getElementsByClassName(
                "projectDetail_productPresentation_base_content"
              )[0].className =
                "projectDetail_productPresentation_base_content projectList_move";
              that.getProjectInfo(that.collectionList[val.realIndex].projectId);
              setTimeout(() => {
                document.getElementsByClassName(
                  "projectDetail_productPresentation_base_content"
                )[0].className =
                  "projectDetail_productPresentation_base_content";
              }, 800);
            },
          },
        });
      }, 800);
    });
  },
  methods: {
    changeSlide(index) {
      this.container1.slideTo(index);
    },
    showDDialog() {
      if (window.innerWidth < 1280) {
      } else {
        this.dynamicDialogWidth = "1300px";
      }
      setTimeout(() => {
        if (this.trendsListAll.length > 0) {
          this.dynamicDialogVisible = true;
        }

        if (window.innerWidth < 1280) {
          document.getElementsByClassName("el-dialog")[0].style =
            "transform: scale(" +
            window.innerWidth / 1280 +
            ") translate(-50%, -50%);transform-origin: 0 0;position: absolute;top: 50%;left: 50%;width: 200%;";
        }
      }, 400);
    },
    changeBase(index) {
      if (index == -1) {
        return;
      }
      if (index == this.collectionList.length) {
        return;
      }
      this.container4.slideTo(index);
      this.showProjectBaseIndex = index;
    },
    showImageDialog(imageArr, index) {
      console.log(imageArr, index);
      ImagePreview({ images: imageArr, startPosition: index });
    },
    toPage(company) {
      this.$store.commit("setCompany", company);
      if (company.companyLevel == 1) {
        this.$router.push({ path: `/` });
      }
      if (company.companyLevel == 2) {
        this.$router.push({ path: `/ProvincialCompany` });
      }
      if (company.companyLevel == 3) {
        this.$router.push({ path: `/cityCompany` });
      }
      if (company.companyLevel == 4) {
        this.$router.push({ path: `/areaCompany` });
      }
    },
    getWXInfo() {
      const that = this;
      getSignature({ pageUrl: window.location.href }).then((res) => {
        const timestamp = res.data.timestamp;
        const nonceStr = res.data.noncestr;
        const signature = res.data.signature;
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: "wxad8dd02ae97d307f", // 必填，公众号的唯一标识
          timestamp: timestamp, // 必填，生成签名的时间戳
          nonceStr: nonceStr, // 必填，生成签名的随机串
          signature: signature, // 必填，签名
          jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"], // 必填，需要使用的JS接口列表
        });
        wx.ready(function() {
          //需在用户可能点击分享按钮前就先调用
          const obj = {
            title: that.projectInfo.projectDTO.projectName, // 分享标题
            desc: that.projectInfo.projectDTO.projectDesc,
            link:
              window.location.href.split('?')[0] +
              "?companyId=" +
              that.companyItem.companyId +
              "&companyArr=" +
              JSON.stringify(that.$store.getters.getCompanyTier) +
              "&id=" +
              that.projectId, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: "https://www.zoneyu.cc/img/whq1.aa941a7f.jpg", // 分享图标
          };
          wx.updateAppMessageShareData(obj);
          wx.updateTimelineShareData(obj);
        });
      });
    },
    downloadFile(url) {
      const a = document.createElement("a");
      a.style.display = "none";
      const name = url.split("/");
      a.download = name[name.length - 1];
      a.href = url;
      a.target = "_blank";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    getScheduleList() {
      getProgress({ projectId: this.projectId, current: 1, size: 1000 }).then(
        (res) => {
          this.scheduleList = res.data.list;
          this.scheduleList.forEach((item) => {
            item.img = [];
            const img = item.progressImg.split(",");
            img.forEach((val) => {
              if (val) {
                item.img.push(val);
              }
            });
          });
          this.scheduleList = this.scheduleList.reverse();
          if (
            !localStorage.getItem("showProgessTips") ||
            (this.scheduleList[0] &&
              localStorage.getItem("showProgessDate") !=
                this.scheduleList[0].progressDate)
          ) {
            this.showProgessTips = true;
          } else {
            this.showProgessTips = false;
          }
        }
      );
    },
    changeSite() {
      if (window.innerWidth < 1280) {
      } else {
        this.siteDialogWidth = "1000px";
      }
      setTimeout(() => {
        if (this.siteList && this.siteList.length > 0) {
          this.siteDialogVisible = true;
        }

        if (window.innerWidth < 1280) {
          document.getElementsByClassName("el-dialog")[0].style =
            "transform: scale(" +
            window.innerWidth / 1280 +
            ") translate(-50%, -50%);transform-origin: 0 0;position: absolute;top: 50%;left: 50%;width: 200%;";
        }
      }, 400);
    },
    changeReport() {
      if (!this.reportList[0].predicted_Yield) {
        return;
      }
      if (window.innerWidth < 1280) {
      } else {
        this.reportDialogWidth = "1000px";
      }
      setTimeout(() => {
        if (this.reportList.length > 0) {
          this.reportDialogVisible = true;
        }
        if (window.innerWidth < 1280) {
          document.getElementsByClassName(
            "report_dialog_outside"
          )[0].childNodes[0].style =
            "transform: scale(" +
            window.innerWidth / 1280 +
            ") translate(-50%, -50%);transform-origin: 0 0;position: absolute;top: 50%;left: 50%;width: 200%;";
        }
      }, 400);
    },
    changeProjectInsure() {
      if (this.projectInsureList.length) {
        this.triggerClickImgList("reportImgList1", this.projectInsureList);
      }
    },
    triggerClickImgList(refName, reportObjImg) {
      this.srcList1 = reportObjImg.map((val) => {
        return val.url;
      });
      this.$refs[refName].showViewer = true;
    },
    invalidClick(e) {
      if (
        e.target.className == "report_dialog_outside" ||
        e.target.className == "report_dialog"
      ) {
        this.reportDialogVisible = false;
      }
    },
    changeContainer5(index) {
      this.productsActiveIndex = 0;
      if (index == -1) this.$refs.products.prev();
      if (index == 1) this.$refs.products.next();
    },
    setTopAndIndex(index) {
      this.activeIndex = index;
      let scale = 1;
      if (window.innerWidth < 500) {
        scale = window.innerWidth / 1240;
      }
      if (index == 0) window.scrollTo(0, 1032 * scale);
      if (index == 1) {
        if (!this.projectInfo.base.resource[1].periodName) {
          window.scrollTo(0, (1032 + 1150) * scale);
        } else {
          window.scrollTo(0, (1032 + 1400) * scale);
        }
      }
      if (index == 2) window.scrollTo(0, (1032 + 1400 + 1200) * scale);
      if (index == 3) window.scrollTo(0, (1032 + 1400 + 1200 + 820) * scale);
      if (index == 4)
        window.scrollTo(0, (1032 + 1400 + 1200 + 820 + 1200) * scale);
    },
    isElementInViewport(el) {
      const rect = el.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <=
          (window.innerWidth || document.documentElement.clientWidth)
      );
    },
    slideBanner1() {
      //选中的轮播图
      var box = document.querySelector(".imgList1 .el-carousel__container");
      var startPoint = 0;
      var stopPoint = 0;
      //重置坐标
      var resetPoint = function() {
        startPoint = 0;
        stopPoint = 0;
      };
      //手指按下
      box.addEventListener("touchstart", function(e) {
        //手指点击位置的X坐标
        startPoint = e.changedTouches[0].pageX;
      });
      //手指滑动
      box.addEventListener("touchmove", function(e) {
        //手指滑动后终点位置X的坐标
        stopPoint = e.changedTouches[0].pageX;
      });
      //当手指抬起的时候，判断图片滚动离左右的距离
      let that = this;
      box.addEventListener("touchend", function() {
        if (stopPoint == 0 || startPoint - stopPoint == 0) {
          resetPoint();
          return;
        }
        if (startPoint - stopPoint > 0) {
          resetPoint();
          that.$refs.imgList1.next();
          return;
        }
        if (startPoint - stopPoint < 0) {
          resetPoint();
          that.$refs.imgList1.prev();
          return;
        }
      });
      // 处理鼠标按下
      box.addEventListener("mousedown", function(event) {
        event.preventDefault();
        startPoint = event.pageX;
      });
      // 处理鼠标抬起
      box.addEventListener("mouseup", function(event) {
        event.preventDefault();
        stopPoint = event.pageX;
        if (stopPoint == 0 || startPoint - stopPoint == 0) {
          resetPoint();
          return;
        }
        if (startPoint - stopPoint > 0) {
          resetPoint();
          that.$refs.imgList1.next();
          return;
        }
        if (startPoint - stopPoint < 0) {
          resetPoint();
          that.$refs.imgList1.prev();
          return;
        }
      });
    },
    slideBanner2() {
      //选中的轮播图
      var box = document.querySelector(".imgList2 .el-carousel__container");
      var startPoint = 0;
      var stopPoint = 0;
      //重置坐标
      var resetPoint = function() {
        startPoint = 0;
        stopPoint = 0;
      };
      //手指按下
      box.addEventListener("touchstart", function(e) {
        //手指点击位置的X坐标
        startPoint = e.changedTouches[0].pageX;
      });
      //手指滑动
      box.addEventListener("touchmove", function(e) {
        //手指滑动后终点位置X的坐标
        stopPoint = e.changedTouches[0].pageX;
      });
      //当手指抬起的时候，判断图片滚动离左右的距离
      let that = this;
      box.addEventListener("touchend", function() {
        if (stopPoint == 0 || startPoint - stopPoint == 0) {
          resetPoint();
          return;
        }
        if (startPoint - stopPoint > 0) {
          resetPoint();
          that.$refs.imgList2.next();
          return;
        }
        if (startPoint - stopPoint < 0) {
          resetPoint();
          that.$refs.imgList2.prev();
          return;
        }
      });
      // 处理鼠标按下
      box.addEventListener("mousedown", function(event) {
        event.preventDefault();
        startPoint = event.pageX;
      });
      // 处理鼠标抬起
      box.addEventListener("mouseup", function(event) {
        event.preventDefault();
        stopPoint = event.pageX;
        if (stopPoint == 0 || startPoint - stopPoint == 0) {
          resetPoint();
          return;
        }
        if (startPoint - stopPoint > 0) {
          resetPoint();
          that.$refs.imgList2.next();
          return;
        }
        if (startPoint - stopPoint < 0) {
          resetPoint();
          that.$refs.imgList2.prev();
          return;
        }
      });
    },
    slideBanner3() {
      //选中的轮播图
      var box = document.querySelector(".imgList3 .el-carousel__container");
      var startPoint = 0;
      var stopPoint = 0;
      //重置坐标
      var resetPoint = function() {
        startPoint = 0;
        stopPoint = 0;
      };
      //手指按下
      box.addEventListener("touchstart", function(e) {
        //手指点击位置的X坐标
        startPoint = e.changedTouches[0].pageX;
      });
      //手指滑动
      box.addEventListener("touchmove", function(e) {
        //手指滑动后终点位置X的坐标
        stopPoint = e.changedTouches[0].pageX;
      });
      //当手指抬起的时候，判断图片滚动离左右的距离
      let that = this;
      box.addEventListener("touchend", function() {
        if (stopPoint == 0 || startPoint - stopPoint == 0) {
          resetPoint();
          return;
        }
        if (startPoint - stopPoint > 0) {
          resetPoint();
          that.$refs.imgList3.next();
          return;
        }
        if (startPoint - stopPoint < 0) {
          resetPoint();
          that.$refs.imgList3.prev();
          return;
        }
      });
      // 处理鼠标按下
      box.addEventListener("mousedown", function(event) {
        event.preventDefault();
        startPoint = event.pageX;
      });
      // 处理鼠标抬起
      box.addEventListener("mouseup", function(event) {
        event.preventDefault();
        stopPoint = event.pageX;
        if (stopPoint == 0 || startPoint - stopPoint == 0) {
          resetPoint();
          return;
        }
        if (startPoint - stopPoint > 0) {
          resetPoint();
          that.$refs.imgList3.next();
          return;
        }
        if (startPoint - stopPoint < 0) {
          resetPoint();
          that.$refs.imgList3.prev();
          return;
        }
      });
    },
    slideBanner4() {
      //选中的轮播图
      var box = document.querySelector(".imgList4 .el-carousel__container");
      var startPoint = 0;
      var stopPoint = 0;
      //重置坐标
      var resetPoint = function() {
        startPoint = 0;
        stopPoint = 0;
      };
      //手指按下
      box.addEventListener("touchstart", function(e) {
        //手指点击位置的X坐标
        startPoint = e.changedTouches[0].pageX;
      });
      //手指滑动
      box.addEventListener("touchmove", function(e) {
        //手指滑动后终点位置X的坐标
        stopPoint = e.changedTouches[0].pageX;
      });
      //当手指抬起的时候，判断图片滚动离左右的距离
      let that = this;
      box.addEventListener("touchend", function() {
        if (stopPoint == 0 || startPoint - stopPoint == 0) {
          resetPoint();
          return;
        }
        if (startPoint - stopPoint > 0) {
          resetPoint();
          that.$refs.imgList4.next();
          return;
        }
        if (startPoint - stopPoint < 0) {
          resetPoint();
          that.$refs.imgList4.prev();
          return;
        }
      });
      // 处理鼠标按下
      box.addEventListener("mousedown", function(event) {
        event.preventDefault();
        startPoint = event.pageX;
      });
      // 处理鼠标抬起
      box.addEventListener("mouseup", function(event) {
        event.preventDefault();
        stopPoint = event.pageX;
        if (stopPoint == 0 || startPoint - stopPoint == 0) {
          resetPoint();
          return;
        }
        if (startPoint - stopPoint > 0) {
          resetPoint();
          that.$refs.imgList4.next();
          return;
        }
        if (startPoint - stopPoint < 0) {
          resetPoint();
          that.$refs.imgList4.prev();
          return;
        }
      });
    },
    changeImageAndVideoIndex(index) {
      this.ImageAndVideoIndex = index;
      this.containerland.slideTo(index, 1000, false);
      if (index == 1) {
        this.imgList2 = [
          "https://shituoshili-dev-001.oss-cn-hangzhou.aliyuncs.com/test/2024-06-05/612ed47a3c7d43a0bac29ec92c3f241b.jpg",
          require("../../static/newImg/img98.jpg"),
        ];
      } else if (index == 0) {
        this.imgList2 = [
          require("../../static/newImg/img95.jpg"),
          "https://shituoshili-dev-001.oss-cn-hangzhou.aliyuncs.com/test/2024-06-05/a0f6fe32e04347b09777330e5dabc153.jpg",
        ];
      } else {
        this.imgList2 = [require("../../static/newImg/img99.jpg")];
      }
    },
    changeImgList1(index) {
      this.container2.slideTo(index);
    },

    getPojectDetail() {
      getPojectDetail(this.projectId).then((res) => {
        this.projectInfo = res.data;
        this.landLength = this.projectInfo.base.resource
          ? this.projectInfo.base.resource.length
          : 0;
        if (!this.projectInfo.base) {
          this.projectInfo.base = {};
        }
        this.projectInfo.landDTOList.forEach((val) => {
          val.landFirstImage = val.landImage.split(",")[0];
        });
        this.companyArr = res.data.cmsCompanies;
        const projectType = JSON.parse(this.projectInfo.projectDTO.projectType);
        this.projectInfo.projectDTO.projectTypearr = [];
        projectType.forEach((val) => {
          if (val.indexOf("0") > -1) {
            this.projectInfo.projectDTO.projectTypearr.push("种子");
          }
          if (val.indexOf("1") > -1) {
            this.projectInfo.projectDTO.projectTypearr.push("种植");
          }
          if (val.indexOf("2") > -1) {
            this.projectInfo.projectDTO.projectTypearr.push("种苗");
          }
          if (val.indexOf("3") > -1) {
            this.projectInfo.projectDTO.projectTypearr.push("科研");
          }
          if (val.indexOf("4") > -1) {
            this.projectInfo.projectDTO.projectTypearr.push("能源");
          }
        });
        this.reportList = JSON.parse(
          this.projectInfo.projectDTO.projectPreProductionReport
        );
        if (this.reportList) {
          this.reportList.forEach((val) => {
            val.reportObjImgList = val.reportObjImg.map((val1) => {
              return val1.url;
            });
          });
        }
        if (JSON.parse(this.projectInfo.projectDTO.projectInsure)) {
          JSON.parse(this.projectInfo.projectDTO.projectInsure).forEach(
            (val) => {
              val.insuranceImg.forEach((val1) => {
                this.projectInsureList.push(val1);
              });
            }
          );
        }
        this.siteList = JSON.parse(this.projectInfo.projectDTO.projectSite);
        if (this.siteList) {
          this.siteList.forEach((val) => {
            val.siteimgList = val.siteimg.map((val1) => {
              return val1.url;
            });
          });
        }

        this.landInfo = this.projectInfo.landDTOList;
        this.landInfo.forEach((val) => {
          if (val && val.landVideo) {
            val.imgLandList = val.landImage
              .split(",")
              .concat(val.landVideo.split(","));
            val.preImgLandList = val.landImage.split(",");
          } else {
            val.imgLandList = val.landImage.split(",");
            val.preImgLandList = val.landImage.split(",");
            if (val.imgLandList[0] == "") {
              val.imgLandList[0] = [
                "https://shituoshili-dev-001.oss-cn-hangzhou.aliyuncs.com/test/2025-01-13/0cef396065674c54b6e62e812da50726.png",
              ];
            }
          }
        });
        this.productList = this.projectInfo.productDTOList;
        this.productList.forEach((val) => {
          val.imgList = val.projectProductImage.split(",");
        });
        this.$nextTick(() => {
          setTimeout(() => {
            this.container1 = new Swiper(".swiper-container1", {
              centeredSlides: true,
              observer: true, //开启动态检查器，监测swiper和slide
              observeParents: true, //监测Swiper 的祖/父元素
            });
          }, 500);
        });
      });
      getPojectCollection(this.projectId).then((res) => {
        this.collectionList = res.data;
        this.getProjectInfo(
          this.collectionList[this.showProjectBaseIndex].projectId
        );
      });
    },
    getProjectInfo(projectId) {
      getPojectDetail(projectId).then((res) => {
        this.projectInfoChild = res.data;
        let projectPreProductionReport = {};
        if (
          this.projectInfoChild.projectDTO.projectPreProductionReport &&
          this.projectInfoChild.projectDTO.projectPreProductionReport != "[]"
        ) {
          projectPreProductionReport = JSON.parse(
            this.projectInfoChild.projectDTO.projectPreProductionReport
          )[0];
        }
        this.projectInfoChild.planting_Density =
          projectPreProductionReport.planting_Density;

        const that = this;
        // if(this.projectInfoChild.projectDTO.projectPreProductionReport != "[]" && this.projectInfoChild.projectDTO.projectPreProductionReport){
        if (
          this.projectInfoChild.base.resource.length == 0 ||
          (this.projectInfoChild.base.resource &&
            this.projectInfoChild.base.resource.length == 1 &&
            (this.projectInfoChild.base.resource[0].images == "" ||
              !this.projectInfoChild.base.resource[0].images))
        ) {
          this.projectInfoChild.base.resource = [
            {
              images:
                "https://shituoshili-dev-001.oss-cn-hangzhou.aliyuncs.com/test/2025-01-13/0d1050c4ac934d7884ae211342b303ad.jpg",
            },
            {
              images:
                "https://shituoshili-dev-001.oss-cn-hangzhou.aliyuncs.com/test/2025-01-13/0d1050c4ac934d7884ae211342b303ad.jpg",
            },
            {
              images:
                "https://shituoshili-dev-001.oss-cn-hangzhou.aliyuncs.com/test/2025-01-13/0d1050c4ac934d7884ae211342b303ad.jpg",
            },
          ];
        }
        if (this.projectInfoChild.base.resource.length == 1) {
          this.projectInfoChild.base.resource.push({
            images:
              "https://shituoshili-dev-001.oss-cn-hangzhou.aliyuncs.com/test/2025-01-13/0d1050c4ac934d7884ae211342b303ad.jpg",
          });
          this.projectInfoChild.base.resource.push({
            images:
              "https://shituoshili-dev-001.oss-cn-hangzhou.aliyuncs.com/test/2025-01-13/0d1050c4ac934d7884ae211342b303ad.jpg",
          });
        }
        if (this.projectInfoChild.base.resource.length == 2) {
          this.projectInfoChild.base.resource.push({
            images:
              "https://shituoshili-dev-001.oss-cn-hangzhou.aliyuncs.com/test/2025-01-13/0d1050c4ac934d7884ae211342b303ad.jpg",
          });
        }
        if (!this.projectInfoChild.base.resource[0].images) {
          this.projectInfoChild.base.resource[0].images = "";
        }
        if (!this.projectInfoChild.base.resource[1].images) {
          this.projectInfoChild.base.resource[1].images = "";
        }
        if (!this.projectInfoChild.base.resource[2].images) {
          this.projectInfoChild.base.resource[2].images = "";
        }
        this.imglist1 = this.projectInfoChild.base.resource[0].images.split(
          ","
        );
        this.preImgList1 = this.projectInfoChild.base.resource[0].images.split(
          ","
        );

        if (
          this.projectInfoChild.base.resource[0].images !=
          "https://shituoshili-dev-001.oss-cn-hangzhou.aliyuncs.com/test/2025-01-13/0d1050c4ac934d7884ae211342b303ad.jpg"
        ) {
          if (
            this.projectInfoChild.base.resource[0] &&
            this.projectInfoChild.base.resource[0].video
          ) {
            this.imglist1 = this.projectInfoChild.base.resource[0].images
              .split(",")
              .concat(this.projectInfoChild.base.resource[0].video.split(","));
            this.preImgList1 = this.projectInfoChild.base.resource[0].images.split(
              ","
            );
          } else {
            this.imglist1 = this.projectInfoChild.base.resource[0]
              ? this.projectInfoChild.base.resource[0].images.split(",")
              : [];
          }
        }

        if (
          this.projectInfoChild.base.resource[1].images !=
          "https://shituoshili-dev-001.oss-cn-hangzhou.aliyuncs.com/test/2025-01-13/0d1050c4ac934d7884ae211342b303ad.jpg"
        ) {
          if (
            this.projectInfoChild.base.resource[1] &&
            this.projectInfoChild.base.resource[1].video
          ) {
            this.imglist1 = this.projectInfoChild.base.resource[1].images
              .split(",")
              .concat(this.projectInfoChild.base.resource[1].video.split(","));
            this.preImgList1 = this.projectInfoChild.base.resource[1].images.split(
              ","
            );
          } else {
            this.imglist1 = this.projectInfoChild.base.resource[1]
              ? this.projectInfoChild.base.resource[1].images.split(",")
              : [];
          }
        }
        if (
          this.projectInfoChild.base.resource[2].images !=
          "https://shituoshili-dev-001.oss-cn-hangzhou.aliyuncs.com/test/2025-01-13/0d1050c4ac934d7884ae211342b303ad.jpg"
        ) {
          if (
            this.projectInfoChild.base.resource[2] &&
            this.projectInfoChild.base.resource[2].video
          ) {
            this.imglist1 = this.projectInfoChild.base.resource[2].images
              .split(",")
              .concat(this.projectInfoChild.base.resource[2].video.split(","));
            this.preImgList1 = this.projectInfoChild.base.resource[2].images.split(
              ","
            );
          } else {
            this.imglist1 = this.projectInfoChild.base.resource[2]
              ? this.projectInfoChild.base.resource[2].images.split(",")
              : [];
          }
        }
        // }
        this.$nextTick(() => {
          this.container2 = new Swiper(".swiper-container2", {
            on: {
              slideChangeTransitionEnd: function(swiper) {
                if (swiper.activeIndex == 1) {
                  if (that.projectInfoChild.base.resource[1].video) {
                    that.imglist1 = that.projectInfoChild.base.resource[1].images
                      .split(",")
                      .concat(
                        that.projectInfoChild.base.resource[1].video.split(",")
                      );
                    that.preImgList1 = that.projectInfoChild.base.resource[1].images.split(
                      ","
                    );
                  } else {
                    that.imglist1 = that.projectInfoChild.base.resource[1].images.split(
                      ","
                    );
                    that.preImgList1 = that.projectInfoChild.base.resource[1].images.split(
                      ","
                    );
                  }
                }
                if (swiper.activeIndex == 0) {
                  if (that.projectInfoChild.base.resource[0].video) {
                    that.imglist1 = that.projectInfoChild.base.resource[0].images
                      .split(",")
                      .concat(
                        that.projectInfoChild.base.resource[0].video.split(",")
                      );
                    that.preImgList1 = that.projectInfoChild.base.resource[0].images.split(
                      ","
                    );
                  } else {
                    that.imglist1 = that.projectInfoChild.base.resource[0].images.split(
                      ","
                    );
                    that.preImgList1 = that.projectInfoChild.base.resource[0].images.split(
                      ","
                    );
                  }
                }
                if (swiper.activeIndex == 2) {
                  if (that.projectInfoChild.base.resource[2].video) {
                    that.imglist1 = that.projectInfoChild.base.resource[2].images
                      .split(",")
                      .concat(
                        that.projectInfoChild.base.resource[2].video.split(",")
                      );
                    that.preImgList1 = that.projectInfoChild.base.resource[2].images.split(
                      ","
                    );
                  } else {
                    that.imglist1 = that.projectInfoChild.base.resource[2].images.split(
                      ","
                    );
                    that.preImgList1 = that.projectInfoChild.base.resource[2].images.split(
                      ","
                    );
                  }
                }
              },
            },
            slidesPerView: 3,
            observer: true, //开启动态检查器，监测swiper和slide
            observeParents: true, //监测Swiper 的祖/父元素
            centeredSlides: true,
          });
          this.container = new Swiper(".swiper-container", {
            slidesPerView: 4,
            spaceBetween: 0,
          });
        });
      });
      // projectInfo
    },
    prevOnclick() {
      this.$refs.switchover.prev();
    },
    nextOnclick() {
      this.$refs.switchover.next();
    },
    setImgAndVideo() {
      const val = this.projectInfo.base.resource[this.container1Index];
      this.imgAndVideo = [];
      if (val.images) {
        const images = val.images.split(",");
        images.forEach((url) => {
          this.imgAndVideo.push({ type: "img", url });
        });
      }
      if (val.video) {
        const videos = val.video.split(",");
        videos.forEach((url) => {
          this.imgAndVideo.push({ type: "video", url });
        });
      }
      // imgAndVideo为接口获得
      this.imglist1.forEach((val, index) => {
        if (val.indexOf(".mp4") > -1) {
          setTimeout(() => {
            this.initVideo(val, index);
          }, 1000);
        }
      });
    },
    initVideo(val, index) {
      this.$nextTick(() => {
        // if (this.deviceType == "IOS") {
        //   const videoPlayer = document.getElementById("videoPlayer" + index)
        //   videoPlayer.addEventListener('play', function () { //播放开始执行的函数
        //     setTimeout(() => {
        //       videoPlayer.load();
        //     }, videoPlayer.duration * 1000 + 500)
        //   });
        // } else {
        this["myPlayer" + index] = this.$video(
          document.getElementById("videoPlayer" + index),
          {
            controls: true,
            autoplay: false,
            preload: "auto",
            controlBar: {
              playToggle: true,
            },
          }
        );
        this["myPlayer" + index].src(this.imglist1[index]); // 重新初始化URL
        this["myPlayer" + index].on("ended", () => {
          // 当播放完成时，执行dispose操作
          this["myPlayer" + index].load();
        });
        if (this.deviceType == "IOS") {
          this["myPlayer" + index].on("play", () => {
            // 当播放完成时，执行dispose操作
            setTimeout(() => {
              this["myPlayer" + index].load();
            }, 7 * 1000 + 200);
            // this['myPlayer' + index].load();
          });
        }
        // }
      });
    },
    changeCarousel(index) {
      if (index == 1) {
        this.$refs.projectCarousel.next();
      } else {
        this.$refs.projectCarousel.prev();
      }
    },
    changeContainer2(index) {
      this.container2.slideTo(index);
      // this.$refs.projectCarousel.setActiveItem(index);
    },
    changeAreaCarousel(index) {
      if (index == 1) {
        this.$refs.areaCarousel.next();
      } else {
        this.$refs.areaCarousel.prev();
      }
    },
    getTrends() {
      getTrends({
        size: 100000,
        current: this.current,
        projectId: this.projectId,
      }).then((res) => {
        res.data.list.forEach((val) => {
          const inspector = val.inspector.split("");
          val.inspector = val.inspector.replace(inspector[1], "*");
          if (val.trendsContent) {
            val.imgList = [];
            const img = val.trendsContent.split(",");
            img.forEach((val1) => {
              if (val1) {
                val.imgList.push(val1);
              }
            });
          } else {
            val.imgList = [];
          }
        });
        if (res.data.list.length) {
          res.data.list.forEach((val) => {
            getPojectDetail(val.projectId).then((res) => {
              val.otherProjectName = res.data.projectDTO.projectName;
            });
            val.preImgList2 = val.trendsContent.split(",").slice(0, 3);
          });
        }
        this.trendsListAll = res.data.list;
        this.trendsList = res.data.list.slice(0, 3);
      });
    },
    toDetail(projectId, type) {
      this.$router.push({
        path: "/projectDetail",
        query: { id: projectId, type },
      });
    },
    styidclick(index) {
      this.styId = index;
      // if (this.ImageAndVideo[this.ImageAndVideoIndex].type == "video") {
      //   this.initVideo();
      // } else {
      //   if (this.myPlayer) {
      //     this.myPlayer.dispose();
      //   }
      // }
      // this.container.slideTo(
      //   Math.floor(this.ImageAndVideo.length / 3),
      //   1000,
      //   false
      // );
      // this.scrollToVisible(index);
    },
  },
  beforeDestroy() {},
};
</script>
<style scoped lang="scss">
.projectDetail {
  min-width: 1280px;
  width: 100%;

  .projectDetail_head {
    height: 2668px;
    background: url("https://shituoshili-dev-001.oss-cn-hangzhou.aliyuncs.com/test/2024-06-05/e22440529e2f4c0887e9724ecbc4caba.png")
      no-repeat;
    background-size: cover;

    .projectDetail_head_content {
      width: 1200px;
      margin: 0 auto;
      padding-top: 150px;
      text-align: center;

      // .projectBrief {
      //   background: url("../../static/newImg/projectDetail_bg2.png") no-repeat;
      //   height: 390px;
      // }
      .projectDetail_head_content_projectName {
        width: 100%;
        font-size: 56px;
        color: #ffffff;
        line-height: 56px;
        letter-spacing: 6px;
      }

      .projectDetail_head_content_projectUnit {
        font-size: 30px;
        color: #ffffff;
        line-height: 56px;
        margin-top: 35px;
      }

      .line {
        width: 800px;
        height: 1px;
        background: #ffffff;
        opacity: 0.24;
        margin: 60px auto;
      }

      .projectDetail_head_content_projectDesc {
        font-size: 24px;
        color: #ffffff;
        line-height: 36px;
        margin-bottom: 80px;
      }

      .projectDetail_head_content_projectPrincipal {
        font-size: 24px;
        color: #ffffff;
        line-height: 31px;
        margin-top: 50px;
      }

      .projectDetail_head_content_resource {
        margin-top: 100px;

        .projectDetail_head_content_resource_head {
          margin-bottom: 73px;

          .swiper-container2 {
            width: 780px;
            margin: 0 auto;
            overflow: hidden;

            .swiper-slide-next,
            .swiper-slide-prev {
              font-size: 40px;
              letter-spacing: 1px;
              text-shadow: 8px 13px 12px rgba(0, 0, 0, 0.31);
            }
          }

          .projectDetail_head_content_resource_head_slide {
            font-size: 54px;
            color: #ffffff;
            line-height: 48px;
            box-shadow: 0px 8px 30px 0px rgba(0, 0, 0, 0.4);
            letter-spacing: 2px;

            .swiper-slide-next,
            .swiper-slide-prev {
              font-size: 40px;
              letter-spacing: 1px;
              text-shadow: 8px 13px 12px rgba(0, 0, 0, 0.31);
            }
          }
        }
      }

      .projectDetail_head_content_list {
        margin-top: 100px;

        .projectDetail_head_content_title {
          font-size: 36px;
          color: #ffffff;
          line-height: 43px;
          letter-spacing: 2px;

          .projectDetail_head_content_title_left,
          .projectDetail_head_content_title_right {
            font-size: 12px;
            display: inline-block;
            vertical-align: middle;
          }
        }

        .projectDetail_head_content_list_project {
          margin-top: 40px;
          display: flex;
          justify-content: center;

          .projectDetail_head_content_list_project_item {
            width: 720px;

            .swiper-container1 {
              width: 100%;
              height: 100%;
              overflow: hidden;

              .swiper-slide {
                overflow: hidden;
              }

              .swiper-slide-next {
                font-weight: bold;
              }
            }

            .projectDetail_head_content_list_project_item_img {
              width: 720px;
              overflow: hidden;

              img {
                display: block;
              }
            }

            .projectDetail_head_content_list_project_item_content {
              overflow: hidden;
              width: 640px;
              height: 370px;
              background: rgba(255, 255, 255, 0.06);
              border-radius: 7px;
              padding: 40px;
              text-align: left;

              .projectDetail_head_content_list_project_item_content_projectProductName {
                font-size: 32px;
                color: #ffffff;
                line-height: 32px;
                letter-spacing: 1px;
                display: inline-block;
                vertical-align: bottom;
              }

              .projectDetail_head_content_list_project_item_content_projectProductCode {
                font-size: 24px;
                color: #ffffff;
                letter-spacing: 1px;
                display: inline-block;
                margin-left: 25px;
              }

              .projectDetail_head_content_list_project_item_content_projectProductDesc {
                font-size: 18px;
                font-weight: 400;
                color: #ffffff;
                line-height: 34px;
                letter-spacing: 1px;
                margin-top: 30px;
              }
            }
          }
        }
      }
    }
  }

  .projectDetail_top {
    width: 100%;
    text-align: center;
    position: relative;
    background: url("../../static/newImg/projectList_bg2.jpg");
    background-repeat: no-repeat;
    background-size: cover;

    .projectDetail_top_area {
      padding-top: 200px;
      width: 100%;
      text-align: center;
      color: #ffffff;
      letter-spacing: 2px;

      .projectDetail_top_projectName {
        width: 1280px;
        height: 56px;
        margin: 0 auto;
        font-size: 56px;
        font-weight: bold;
        letter-spacing: 2px;
        font-family: 宋体;
        display: flex;
        justify-content: center;
      }

      .projectDetail_top_area_projectPrincipal {
        font-size: 21px;
        color: #ffffff;
        display: flex;
        justify-content: center;
        letter-spacing: 1px;

        .duangang {
          margin: 0 25px;
        }

        img {
          margin: 5px;
          margin-bottom: 0;
          margin-right: 10px;
          width: 28px;
          height: 34px;
        }

        a {
          color: #1e6314;
          cursor: pointer;
        }
      }

      .projectDetail_top_area_line {
        width: 1200px;
        height: 1px;
        background: #ffffff;
        opacity: 0.13;
        margin: 28px auto;
      }
    }

    .projectDetail_bottom_title {
      position: absolute;
      bottom: 0 !important;
      left: 0;
      width: 100%;
      height: 70px;
      background: rgba(108, 149, 85, 0.52);
      z-index: 3;

      .projectDetail_bottom_title_outSide {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: center;

        .projectDetail_bottom_title_item {
          font-size: 24px;
          color: #ffffff;
          line-height: 70px;
          width: 240px;
          cursor: pointer;
          position: relative;

          .projectDetail_bottom_title_item_new {
            position: absolute;
            top: 15px;
            right: 45px;
          }
        }

        .projectDetail_bottom_title_item:hover {
          background-image: url("../../static/newImg/projectDetail_bottom_title_outSide_bg1.png");
          background-repeat: no-repeat;
          background-size: cover;
          background-position: center;
        }

        .active {
          background-image: url("../../static/newImg/projectDetail_bottom_title_outSide_bg.png") !important;
          background-repeat: no-repeat;
          background-size: cover !important;
          background-position: center;
          color: #354a32;
        }
      }
    }

    .projectDetail_top_area_unit {
      margin: 0 auto;
      margin-top: 50px;
      font-size: 20px;
      letter-spacing: 1px;
      width: 900px;
      height: 72px;
      line-height: 72px;
      background-image: url("../../static/newImg/projectList_bg1.png");
      background-size: contain;
      background-position: center;
    }

    .projectDetail_top_area_projectDesc {
      width: 1360px;
      margin: 0 auto;
      font-size: 21px;
      color: #ffffff;
      text-align: center;
      line-height: 36px;
    }

    .projectDetail_top_area_download {
      display: flex;
      justify-content: center;
      margin: 50px auto 0 auto;
    }
    .projectDetail_product {
      width: 1280px;
      height: 580px;
      background-image: url("../../static/newImg/projectList_bg7.png");
      background-size: cover;
      margin: 50px auto;
      text-align: center;
    }
    .projectDetail_news {
      width: 1280px;
      margin: 50px auto;
      text-align: center;
      border-radius: 48px;
      background: linear-gradient(
        180deg,
        rgba(111, 183, 125, 0.05) 0%,
        rgba(32, 94, 45, 0.49) 50%,
        rgba(24, 80, 45, 0.1) 100%
      );
    }
  }

  .projectDetail_productPresentation_projectBrief {
    height: 820px;
    color: #fff;
    background: url("https://shituoshili-dev-001.oss-cn-hangzhou.aliyuncs.com/test/2024-06-05/357d197f8b2349f8b17becb4ce00d5c6.png")
      no-repeat;
    background-size: cover;
    position: relative;

    .projectDetail_productPresentation_projectBrief_content {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 1200px;
      margin: 0 auto;
      text-align: center;

      .projectDetail_productPresentation_projectBrief_content_outside {
        display: flex;
        align-items: center;
        justify-content: space-around;
      }

      .projectDetail_productPresentation_projectBrief_content_left,
      .projectDetail_productPresentation_projectBrief_content_right {
        cursor: pointer;
        opacity: 0.8;
      }

      .projectDetail_productPresentation_projectBrief_content_list {
        overflow: hidden;
        width: 1000px;
        position: relative;

        .productList_bg {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 90px;
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0) 0%,
            rgba(1, 28, 8, 0.69) 100%
          );
          z-index: 9;

          .productList_bg_item {
            display: inline-block;
            padding: 12px 4px;
            background-color: transparent;
            cursor: pointer;

            .productList_bg_item_point {
              display: block;
              opacity: 0.48;
              background-color: #fff;
              border: none;
              outline: 0;
              padding: 0;
              margin: 0;
              cursor: pointer;
              transition: 0.3s;
              width: 10px;
              height: 10px;
              border-radius: 25px;
            }
          }

          .active {
            .productList_bg_item_point {
              width: 20px;
              opacity: 1;
            }
          }
        }

        .productPresentation_top_area_left,
        .productPresentation_top_area_right {
          border-radius: 50%;
          width: 86px;
          height: 86px;
          background: #ffffff;
          color: #000;
          line-height: 86px;
          font-size: 36px;
          opacity: 0.47;
        }
      }
    }

    .projectDetail_productPresentation_projectBrief_list {
      display: flex;

      .projectDetail_productPresentation_projectBrief_list_item_img {
        width: 60%;
        height: 400px;
        overflow: hidden;
        position: relative;
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;

        img {
          display: block;
        }

        .projectDetail_productPresentation_projectBrief_list_item_img_tips {
          position: absolute;
          top: 25px;
          left: 30px;
          width: 126px;
          height: 40px;
          background: rgba(0, 0, 0, 0.7);
          border-radius: 24px;
          font-weight: bold;
          font-size: 16px;
          color: #ffffff;
          line-height: 40px;
          text-align: center;
        }
      }

      .projectDetail_productPresentation_projectBrief_list_item_intro {
        width: 40%;
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;
        height: 340px;
        background: rgba(255, 255, 255, 0.06);
        padding: 30px;
        text-align: left;

        .projectDetail_productPresentation_projectBrief_list_item_intro_title {
          font-size: 30px;
          color: #ffffff;
          line-height: 21px;
          letter-spacing: 1px;
          margin-top: 30px;
        }

        .projectDetail_productPresentation_projectBrief_list_item_intro_tips {
          font-size: 16px;
          margin-top: 28px;
          line-height: 30px;
        }
      }
    }

    .carousel_right {
      // flex: 0.9;
      // z-index: -1;
      margin: 25px 0;
      padding: 34px;
      width: 520px;
      // height: 316px;
      background: #ffffff;
      border-radius: 7px;
      background: rgba(255, 255, 255, 0.06);
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;

      img {
        width: 17px;
        height: 19px;
      }
    }

    .carousel_left {
      height: 366px;
      position: relative;
    }

    .right_img {
      z-index: 12;
      transform: rotate(0.5turn);
      transform: rotate(0.5turn);
      position: absolute;
      width: 60px;
      height: 60px;
      cursor: pointer;
      line-height: 61px;
      background: rgba(0, 0, 0, 0.3);
      border-radius: 50%;
      left: -32px;
      top: calc(50% - 30px);

      img {
        width: 17px;
        height: 19px;
      }
    }

    .left_img {
      z-index: 12;
      position: absolute;
      width: 60px;
      height: 60px;
      cursor: pointer;
      line-height: 67px;
      background: rgba(0, 0, 0, 0.3);
      border-radius: 50%;
      right: -32px;
      top: calc(50% - 30px);

      img {
        width: 17px;
        height: 19px;
      }
    }
  }

  .projectDetail_area {
    height: 1200px;
    background: url("../../static/newImg/projectDetail_bg4.png") no-repeat;
    background-size: cover;
    text-align: center;
    position: relative;

    .projectDetail_area_contentDiv {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 1200px;

      .projectDetail_area_contentDiv_outside {
        border-radius: 20px;
        width: 1200px;
        margin: 50px auto 30px auto;
        height: 776px;
        overflow: hidden;
        box-shadow: 0px 8px 30px 0px rgba(0, 0, 0, 0.4);
        position: relative;

        .projectDetail_area_contentDiv_outside_bg {
          position: absolute;
          bottom: 192px;
          left: 0;
          width: 100%;
          height: 90px;
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0) 0%,
            rgba(1, 28, 8, 0.69) 100%
          );
          z-index: 9;
        }

        ::v-deep .el-carousel__indicators {
          bottom: 220px;
        }

        .projectDetail_area_contentDiv_outside_tips {
          position: absolute;
          bottom: 0;
          left: 0;
          width: calc(100% - 60px);
          height: 132px;
          background: rgba(1, 18, 6, 0.8);
          padding: 30px;
          z-index: 9;

          .projectDetail_area_contentDiv_outside_tips_title {
            font-weight: 500;
            font-size: 24px;
            color: #ffffff;
            text-align: left;
          }

          .projectDetail_area_contentDiv_outside_tips_collect {
            display: flex;
            margin-top: 20px;

            .projectDetail_area_contentDiv_outside_tips_collect_htnx,
            .projectDetail_area_contentDiv_outside_tips_collect_csrq {
              width: 50%;
              font-weight: 400;
              font-size: 18px;
              color: #ffffff;
              text-align: left;
              height: 70px;
              line-height: 35px;
            }

            .projectDetail_area_contentDiv_outside_tips_collect_more {
              width: 20%;
              text-align: right;
            }
          }
        }
      }

      .projectDetail_area_contentDiv_list {
        width: 1200px;
        margin: 0 auto;
        overflow: hidden;

        .projectDetail_area_contentDiv_list_item {
          width: 340px !important;
          text-align: center;
          overflow: hidden;

          .projectDetail_area_contentDiv_list_item_outside {
            overflow: hidden;
            border: 8px solid transparent;
            height: 150px;
            position: relative;
          }

          .projectDetail_area_contentDiv_list_item_tips {
            font-size: 20px;
            color: #354a32;
            text-align: center;
            margin-top: 30px;
          }

          img {
            width: 385px;
            display: block;
          }
        }

        .active {
          border: 8px solid #26770c !important;
        }
      }
    }

    .projectDetail_area_title {
      text-align: center;
      font-size: 36px;
      font-weight: bold;
      color: #354a32;
      line-height: 43px;

      .projectDetail_area_title_left,
      .projectDetail_area_title_right {
        font-size: 12px;
        display: inline-block;
        vertical-align: middle;
      }
    }

    .projectDetail_area_content_left {
      display: inline-block;
      transform: rotate(180deg);
      cursor: pointer;
    }

    .projectDetail_area_content_right {
      display: inline-block;
      cursor: pointer;
    }

    .projectDetail_area_content {
      width: 1200px;
      padding: 0 50px;
      height: 506px;
      margin: 0 auto;
      vertical-align: middle;
      display: inline-block;

      .projectDetail_area_content_item {
        display: flex;
        cursor: pointer;
        justify-content: center;

        .projectDetail_area_content_item_img {
          overflow: hidden;
          position: relative;

          .R_btn {
            position: absolute;
            width: 100px;
            line-height: 40px;
            top: 20px;
            left: 20px;
            height: 40px;
            background: #000000;
            border-radius: 24px;
          }
        }

        .projectDetail_area_content_item_right {
          width: 480px;
          background: #ffffff;
          box-shadow: 0px 2px 11px 0px rgba(53, 74, 50, 0.07);
          padding: 40px 0 34px 36px;
          font-size: 18px;
          // width: 480px;
          font-weight: bold;
          color: #354a32;
          line-height: 20px;
          text-align: left;

          .ispan {
            display: inline-block;
            margin-bottom: 20px;
          }

          .bbtn {
            width: 124px;
            height: 42px;
            background: #354a32;
            border-radius: 21px;
            margin-top: 45px;
          }

          .whippletree {
            width: 90%;
            height: 1px;
            margin-bottom: 20px;
            background: rgb(53, 74, 50);
            opacity: 0.22;
          }

          div {
            display: inline-block;
            width: 90px;
          }

          .projectDetail_area_content_item_right_label {
            // width: 320px;
            // width: 100%;
            display: inline-block;
            font-size: 18px;
            font-weight: 400;
            color: #6b766a;
            line-height: 20px;
            margin-top: 24px;
            letter-spacing: 1px;
          }
        }
      }
    }
  }

  .projectDetail_dynamic {
    background: url("https://shituoshili-dev-001.oss-cn-hangzhou.aliyuncs.com/test/2024-06-05/d9fedc4583854c0f9ac650666b6befb3.jpg")
      no-repeat;
    background-size: 100%;
    padding: 150px 0;

    .projectDetail_dynamic_title {
      text-align: center;
      font-size: 36px;
      color: #354a32;
      font-weight: bold;
      line-height: 43px;
      margin-bottom: 100px;

      .projectDetail_dynamic_title_left,
      .projectDetail_dynamic_title_right {
        font-size: 12px;
        display: inline-block;
        vertical-align: middle;
      }
    }

    .projectDetail_dynamic_list {
      width: 1200px;
      margin: 0 auto;
      text-align: left;

      .projectDetail_dynamic_list_time {
        font-size: 40px;
        font-weight: bold;
        color: #252525;
        line-height: 62px;
        display: inline-block;
        vertical-align: top;
        margin-left: 30px;
      }

      .projectDetail_dynamic_list_line {
        margin: 0 29px;
        border-left: 4px solid #f5f5f7;

        .projectDetail_dynamic_list_line_inside {
          padding: 40px 60px;
          border-radius: 27px;

          .projectDetail_dynamic_list_line_bg {
            background: linear-gradient(180deg, #f5f5f7 0%, #ffffff 100%);
            width: calc(100% - 80px);
            border-radius: 27px;
            padding: 40px;

            .projectDetail_dynamic_list_line_name {
              font-size: 40px;
              font-weight: bold;
              color: #252525;
              line-height: 36px;
            }

            .projectDetail_dynamic_list_line_content {
              font-size: 32px;
              font-weight: 500;
              color: #595959;
              margin: 40px 0;
            }

            .projectDetail_dynamic_list_line_img {
              display: flex;
              flex-wrap: wrap;

              .el-image,
              img {
                width: 31%;
                margin: 1% 0 0 1%;
                object-fit: cover;
              }
            }

            .projectDetail_dynamic_list_line_tips {
              width: 107px;
              height: 34px;
              background: #ba883f;
              border-radius: 4px;
              font-size: 18px;
              font-weight: 400;
              color: #ffffff;
              line-height: 34px;
              letter-spacing: 1px;
              margin-top: 42px;
              text-align: center;
            }
          }
        }
      }

      .projectDetail_dynamic_list_more {
        width: 1000px;
        height: 120px;
        background: #f5f5f7;
        border-radius: 13px;
        text-align: center;
        font-size: 32px;
        font-weight: 400;
        color: #252525;
        line-height: 120px;
        margin-left: 96px;
        cursor: pointer;
      }
    }
  }

  .projectDetail_productPresentation_base {
    padding-bottom: 50px;
    padding-top: 50px;
    color: #fff;
    background-size: cover;
    text-align: center;
    background: url("../../static/newImg/projectList_bg10.jpg") no-repeat;
    background-size: cover;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    .projectDetail_productPresentation_base_content {
      width: 1120px;
      margin: 0 64px;
      padding: 0 90px 80px 90px;
      border-radius: 48px;
      background: linear-gradient(
        180deg,
        rgba(111, 183, 125, 0.05) 0%,
        rgba(32, 94, 45, 0.49) 50%,
        rgba(24, 80, 45, 0.1) 100%
      );
    }

    .el-carousel_head_content_title_left {
      margin-top: 30px;

      ::v-deep .el-carousel__indicators {
        bottom: 30px;
      }

      .carousel_left {
        width: 100%;
        overflow: hidden;
        border-radius: 20px;
        box-shadow: 0px 8px 30px 0px rgba(0, 0, 0, 0.4);
        position: relative;

        .carousel_left_bg {
          position: absolute;
          bottom: -2px;
          left: 0;
          width: 100%;
          height: 150px;
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0.78) 100%
          );
        }
      }
    }

    .mask {
      width: 640px;
      background: #000;
      height: 60px;
      position: absolute;
      bottom: 0px;
      opacity: 0.6;
    }

    .projectDetail_head_content_resource_head {
      margin-top: 100px;

      // margin-bottom: 73px;
      .swiper-container2 {
        width: 800px;
        margin: 0 auto;
        height: 70px;
        overflow: hidden;

        .swiper-slide-next,
        .swiper-slide-prev {
          font-size: 32px;
          opacity: 0.5;
          letter-spacing: 1px;
        }
      }

      .swiper-slide {
        opacity: 0.15;
        font-size: 40px !important;
      }

      .swiper-slide-active {
        opacity: 1;
        font-size: 54px !important;
      }

      .projectDetail_head_content_resource_head_slide {
        // font-size: 44px;
        color: #ffffff;
        line-height: 48px;
        letter-spacing: 2px;

        .swiper-slide-next,
        .swiper-slide-prev {
          font-size: 40px;
          letter-spacing: 1px;
          text-shadow: 8px 13px 12px rgba(0, 0, 0, 0.31);
        }
      }
    }
  }

  .ProjectBase {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 40px;
    font-size: 20px;
    color: #ebffe8;

    .ProjectBase_punctuation {
      font-size: 20px;
      margin: 0 20px;
    }
  }

  .ProjectBase1 {
    display: flex;
    justify-content: center;
    font-size: 20px;
    background-image: url("../../static/newImg/tripartite_bg.png");
    background-repeat: no-repeat;
    background-size: 100% 167px;
    color: #ebffe8;

    div {
      text-align: left;
    }

    .ProjectBase1_btn {
      height: 34px;
      padding: 0 9px;
      background: linear-gradient(
        128deg,
        #fff3a0 0%,
        #e5a449 57%,
        #f2ba55 100%
      );
      border-radius: 6px;
      font-size: 14px;
      color: #412d10;
      line-height: 34px;
      display: inline-block;
      cursor: pointer;
    }
  }

  .projectDetail_productPresentation_Schedule {
    height: 1200px;
    background-size: cover;
    text-align: center;
    background: url("https://shituoshili-dev-001.oss-cn-hangzhou.aliyuncs.com/test/2024-06-05/acb390c7d99347e0b8e60d9644de07b9.png")
      no-repeat;
    background-size: cover;
    position: relative;

    .productPresentation_top_area_Schedule {
      font-size: 36px;
      width: 1200px;
      margin: 0 auto;
      font-weight: bold;
      color: #ffffff;
      padding-top: 137px;
    }

    .projectDetail_productPresentation_Schedule_content {
      overflow: hidden;
    }

    .projectDetail_productPresentation_Schedule_content_line {
      margin: 200px 0 50px 0;
      position: relative;

      .swiper-container3 {
        width: 1200px;
        position: absolute;
        top: -109px;
        left: 50%;
        transform: translate(-50%, 0);
      }

      .projectDetail_productPresentation_Schedule_content_line_1 {
        background-color: #6b766a;
        height: 2px;
        width: 100%;
      }

      .projectDetail_productPresentation_Schedule_content_line_item {
        // width: 310px !important;
        font-size: 22px;
        color: #ffffff;
        text-align: center;
        cursor: pointer;

        .projectDetail_productPresentation_Schedule_content_line_item_date {
          margin-top: 10px;
          opacity: 0.2;
        }

        .projectDetail_productPresentation_Schedule_content_line_item_activeIcon {
          display: none;
        }

        .projectDetail_productPresentation_Schedule_content_line_item_circle {
          width: 20px;
          height: 20px;
          background: #284822;
          border-radius: 50%;
          border: 4px solid #6b766a5b;
          margin: 17px auto 0 auto;
        }

        .projectDetail_productPresentation_Schedule_content_line_item_name {
          margin-top: 24px;
          font-size: 20px;
          opacity: 0.2;
        }

        .projectDetail_productPresentation_Schedule_content_line_item_icon {
          margin-top: 15px;
          opacity: 0.2;
        }
      }

      .active {
        div {
          opacity: 1 !important;
        }

        .projectDetail_productPresentation_Schedule_content_line_item_circle {
          border: 4px solid #ffffff;
        }

        .projectDetail_productPresentation_Schedule_content_line_item_activeIcon {
          display: block;
          color: #ffffff;
          font-weight: bold;
          margin-top: 10px;
        }

        .projectDetail_productPresentation_Schedule_content_line_item_name {
          margin-top: 10px;
        }
      }
    }

    .projectDetail_productPresentation_Schedule_content_outside {
      width: 1200px;
      margin: 150px auto 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-evenly;

      .projectDetail_productPresentation_Schedule_content_left,
      .projectDetail_productPresentation_Schedule_content_right {
        cursor: pointer;
        opacity: 0.8;
      }

      .showBtn {
        opacity: 0;
      }
    }

    .projectDetail_productPresentation_Schedule_content_list {
      width: 900px;
      height: 326px;
      padding: 50px;
      background: #ffffff;
      border-radius: 8px;
      display: flex;
      justify-content: space-around;
      transition: all 0.2s linear;

      img {
        border-radius: 8px;
      }

      .projectDetail_productPresentation_Schedule_content_list_img {
        width: 500px;
        height: 326px;
        overflow: hidden;
      }

      .projectDetail_productPresentation_Schedule_content_list_content {
        width: 370px;
        position: relative;

        .projectDetail_productPresentation_Schedule_content_list_content_nav {
          width: 40px;
          height: 4px;
          background: #354a32;
          border-radius: 3px;
        }

        .projectDetail_productPresentation_Schedule_content_list_content_tips {
          margin-top: 10px;
          font-weight: 500;
          font-size: 22px;
          color: #565759;
          line-height: 32px;
          letter-spacing: 1px;
          text-align: left;
        }

        .projectDetail_productPresentation_Schedule_content_list_content_file {
          font-size: 16px;
          margin-top: 25px;
          color: #19812c;
          cursor: pointer;
          text-align: left;
          margin-top: 30px;
          cursor: pointer;
        }

        .projectDetail_productPresentation_Schedule_content_list_content_date {
          font-weight: 400;
          font-size: 20px;
          color: #565759;
          line-height: 30px;
          letter-spacing: 1px;
          text-align: left;
          position: absolute;
          bottom: 0;
          left: 0;
        }

        .projectDetail_productPresentation_Schedule_content_list_content_more {
          position: absolute;
          bottom: 0;
          right: 0;
          width: 62px;
          height: 62px;
          line-height: 62px;
          border-radius: 50%;
          font-size: 24px;
          background: rgba(0, 0, 0, 0.25);
          color: #fff;
        }
      }
    }

    .moveleft {
      transform: translateY(20px);
      opacity: 0.7;
    }

    .projectDetail_productPresentation_Schedule_content_more {
      margin: 138px auto;
      width: 260px;
      height: 68px;
      background: #354a32;
      border-radius: 34px;
      font-weight: 500;
      font-size: 23px;
      color: #ffffff;
      line-height: 68px;
    }
  }
}

.site_dialog_outside {
  overflow: hidden;

  .site_Dialog {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    padding: 0 20px;

    .site_Dialog_item {
      width: 100%;
      font-size: 16px;
      color: #595959;
      padding-bottom: 30px;
      margin-bottom: 30px;
      border-bottom: 1px solid #f5f5f7;
      display: flex;

      .site_Dialog_item_img {
        width: 40%;
        height: 140px;
        overflow: hidden;
      }

      .site_Dialog_item_title {
        width: calc(70%);
        margin-top: 8px;

        .site_Dialog_item_title_label {
          margin-bottom: 12px;
          font-size: 18px;
          color: #252525;

          span {
            display: inline-block;
            width: 100px;
            color: #787878;
          }
        }

        .site_Dialog_item_title_label:last-child {
          margin-bottom: 0;
        }
      }
    }

    .site_Dialog_item:last-child {
      border-bottom: 0;
      padding-bottom: 0;
    }
  }
}

::v-deep .el-dialog {
  transform: translate(0, -50%);
}

.report_dialog_outside {
  overflow: hidden;

  .report_Dialog {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    padding: 0 20px;

    .report_Dialog_item {
      width: 100%;
      height: 200px;
      font-size: 16px;
      color: #595959;
      padding-bottom: 30px;
      margin-bottom: 30px;
      border-bottom: 1px solid #f5f5f7;
      display: flex;

      .report_Dialog_item_img {
        height: 200px;
        width: 300px;
        overflow: hidden;
      }

      .report_Dialog_item_title {
        width: calc(70% - 30px);
        margin-left: 30px;

        .report_Dialog_item_title_label {
          margin-bottom: 12px;
          font-size: 16px;
          color: #252525;

          span {
            display: inline-block;
            width: 85px;
            color: #787878;
          }
        }

        .report_Dialog_item_title_more {
          font-size: 16px;
          margin-top: 25px;
          color: #19812c;
          cursor: pointer;
        }
      }
    }

    .report_Dialog_item:last-child {
      border-bottom: 0;
      padding-bottom: 0;
    }
  }
}

.dynamic_dialog_outside {
  overflow: hidden;
}

.el-carousel_head_content_title_left {
  margin-top: 117px;
}

.el-carousel_head_content_title_left_son {
  width: 1200px;
}

.el-carousel__item h3 {
  color: red;
  font-size: 18px;
  opacity: 0.75;
  line-height: 30px;
  margin: 0;
}

::v-deep .el-carousel__arrow {
  display: none;
}

/* 修改指示器的背景色和边框 */
.el-carousel__indicator {
  background-color: #999;
  border: none;
}

/* 修改激活状态下的指示器样式 */
.el-carousel__indicator.is-active {
  background-color: #333;
}

/* 如果指示器位置在外部，还需要调整外部指示器容器的样式 */
.el-carousel__indicators--outside {
  bottom: 10px;
}

::v-deep .el-carousel__indicators--horizontal {
  bottom: 25px;
}

::v-deep .el-carousel__indicator.is-active button {
  width: 20px;
}

::v-deep .el-carousel__indicators--horizontal {
  bottom: 10px;
}

::v-deep .el-carousel__button {
  width: 10px;
  height: 10px;
  border-radius: 25px;
}

::v-deep .el-dialog__headerbtn {
  font-size: 22px;
}

::v-deep .el-dialog__headerbtn:hover .el-dialog__close {
  color: #155512 !important;
}

::v-deep .video-js {
  width: 100% !important;
  height: 100% !important;
  background-color: #000;

  .vjs-big-play-button {
    width: 100px;
    height: 100px;
    border: 0;
    background-color: rgba(0, 0, 0, 0.67);
    border-radius: 50%;
    line-height: 100px;
    font-size: 80px;
    transform: translate(-50%, -50%);
    margin: 0;
  }
}

.container {
  display: flex;
  overflow-x: hidden;
  width: 660px;

  .inner-container {
    flex-shrink: 0;
    display: flex;
  }

  .selected {
    border: 4px solid #3bac30;
  }
}

.landDetail_head_left_list {
  display: flex;
  // margin-top: 32px;
  width: 660px;

  .landDetail_head_left_list_item {
    width: 130px !important;
    text-align: center;
    border: 3px solid #fff;
    height: 110px;
    overflow: hidden;

    img,
    video {
      max-width: 100%;
      max-height: 100%;
    }
  }

  .active {
    border: 4px solid #3bac30;
  }
}

.text-container {
  position: relative;
  line-height: 1.5;
  max-height: 4.5em;
  overflow: hidden;
  margin-left: 32px;
  margin-top: 12px;
  width: 320px;
  height: 81px;
}

.text-container::after {
  content: "...";
  position: absolute;
  bottom: 0;
  right: 0;
  // background: linear-gradient(to right, transparent, white 100%);
  background: white;
  padding-left: 4px;
}

.projectDetail_bottom_title_outSide {
  .active {
    background-image: url("../../static/newImg/projectDetail_bottom_title_outSide_bg.png") !important;
    background-repeat: no-repeat;
    background-size: cover !important;
    background-position: center;
    color: #354a32;
  }
}

.center_title {
  width: 1600px;
  text-align: left;
  margin: 10px auto 60px auto;
  z-index: 9;
  position: relative;
  line-height: 40px;

  & > img {
    cursor: pointer;
    vertical-align: middle;
  }

  .center_home {
    font-weight: 400;
    font-size: 16px;
    color: #fff;
    vertical-align: middle;
    cursor: pointer;
  }
}

.productPresentation_top_area {
  font-size: 39px;
  font-weight: bold;
  padding: 60px 0 35px 0;
  color: #f9ffd0;
}
.projectList_line {
  width: 1160px;
  height: 6px;
  margin: 0 auto;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    #ffffff 48%,
    rgba(255, 255, 255, 0) 100%
  );
  border-radius: 48px;
  opacity: 0.1;
}

.productPresentation_head_content_title_left,
.productPresentation_head_content_title_right {
  display: inline-block;
  vertical-align: top;
}
.productPresentation_head_content_title_left {
  margin-left: 20px;
}
.productPresentation_head_content_title_right {
  margin-right: 20px;
}
.swiper-container4 {
  height: 90px;
  color: #eee;
  font-size: 24px;
  z-index: 8;
  position: relative;
  .swiper-slide-active {
    // background-color: #106022;
    color: #fff;
    font-size: 26px;
  }
  .swiper-slide-prev {
    background: linear-gradient(
      90deg,
      rgba(216, 216, 216, 0) 30%,
      rgba(238, 238, 238, 0.8) 100%
    );
    -webkit-background-clip: text; /* 兼容WebKit浏览器 */
    background-clip: text;
    color: transparent;
  }
  .swiper-slide-next {
    background: linear-gradient(
      90deg,
      rgba(238, 238, 238, 0.8) 0%,
      rgba(216, 216, 216, 0) 70%
    );
    -webkit-background-clip: text; /* 兼容WebKit浏览器 */
    background-clip: text;
    color: transparent;
  }
}
.projectList_move {
  animation: projectListMove 0.5s linear 1;
}
@keyframes projectListMove {
  0% {
    transform: translateY(100px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.swiper-pagination-bullet1 {
  width: 72px;
  height: 6px;
  background: rgba(255, 255, 255, 0.3);
  margin-right: 8px;
  border-radius: 0;
}
.projectDetail_news_content {
  position: relative;
}
.projectDetail_news_content::before {
  content: " ";
  position: absolute;
  top: 48px;
  left: 14px;
  height: 100%;
  width: 1px;
  background-image: url("../../static/newImg/projectList_bg17.png");
  background-repeat: no-repeat;
  background-size: contain;
}
::-webkit-scrollbar {
  width: 5px; /* 宽度 */
  background-color: transparent;
}
::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.12);
}
</style>
